<template>
  <span v-if="valueSet">
    <slot name="default" v-bind:value="value">
      {{ value }}
    </slot>
  </span>
  <span v-else-if="hideIfNotSet === false">
    <slot name="not-set">
      <v-icon v-if="dash" color="grey lighten-1">mdi-minus</v-icon>
      <span v-else class="not-set">
        ({{$t('not_set')}})
      </span>
    </slot>
  </span>
</template>

<script>
/**
 * Utility component to display values that may or may not be set. This is useful in particular cases where a value
 * that's not set or results in an empty value might result in an error or malformed display, or in cases where we want
 * to call attention to the fact that the value isn't set.
 *
 * The optional 'not-set' slot allows you to customize what's shown if the value is empty.
 */
export default {
  props: {
    /**
     * The value to be evaluated.
     */
    value: {
    },
    /**
     * If true, will not display anything if the value is not set.
     */
    hideIfNotSet: {
      type: Boolean,
      default: false
    },
    /**
     * If true, will display a dash/minus icon instead of "(not set)". I think this looks better on tables.
     */
    dash: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    valueSet () {
      return this.value != null && this.value !== ''
    }
  }
}
</script>

<style scoped>
.not-set {
  color: #9e9e9e;
  font-style: italic;
  white-space: nowrap;
}
</style>
